// extracted by mini-css-extract-plugin
export var container = "_2b-0";
export var disabled = "_2b-4";
export var fullWidth = "_2b-3";
export var lined = "_2b-1";
export var selected = "_2b-5";
export var tab = "_2b-2";